import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import { restoreSession } from './supabase';

Vue.use(ElementUI, { size: 'small' });
Vue.config.productionTip = false;

// 全局响应式视口信息：组件内用 $vp.mobile 做移动端适配（如取消表格固定列）
const viewport = Vue.observable({
  width: window.innerWidth,
  mobile: window.innerWidth <= 768,
});
window.addEventListener('resize', () => {
  viewport.width = window.innerWidth;
  viewport.mobile = window.innerWidth <= 768;
});
Vue.prototype.$vp = viewport;

// 禁止显示 rxgame 占位图：空封面或 placeholder 图一律替换为 hsgame 专属 loading 图
const PLACEHOLDER_COVER_RE = /placeholder\.(jpg|jpeg|png|webp|gif)(\?|$)/i;
Vue.prototype.$hsCover = function (url) {
  const u = String(url || '').trim();
  if (!u || PLACEHOLDER_COVER_RE.test(u)) return '/hsgame-loading.svg';
  return u;
};

// 刷新页面后恢复 Supabase 会话（直连模式）
restoreSession();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
